import { useEffect } from 'react';

interface PageMeta {
  title?: string;
  description?: string;
  path?: string; // e.g. "/pricing" — defaults to current pathname
}

const BASE_URL = 'https://mybracketsim.com';

export function usePageMeta({ title, description, path }: PageMeta = {}) {
  useEffect(() => {
    const canonicalUrl = `${BASE_URL}${path ?? window.location.pathname}`;

    // Update canonical link
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (link) {
      link.href = canonicalUrl;
    } else {
      link = document.createElement('link');
      link.rel = 'canonical';
      link.href = canonicalUrl;
      document.head.appendChild(link);
    }

    // Update og:url
    const ogUrl = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
    if (ogUrl) ogUrl.content = canonicalUrl;

    // Update title
    if (title) {
      document.title = title;
      const ogTitle = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
      if (ogTitle) ogTitle.content = title;
      const twitterTitle = document.querySelector<HTMLMetaElement>('meta[name="twitter:title"]');
      if (twitterTitle) twitterTitle.content = title;
    }

    // Update description
    if (description) {
      const metaDesc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (metaDesc) metaDesc.content = description;
      const ogDesc = document.querySelector<HTMLMetaElement>('meta[property="og:description"]');
      if (ogDesc) ogDesc.content = description;
      const twitterDesc = document.querySelector<HTMLMetaElement>('meta[name="twitter:description"]');
      if (twitterDesc) twitterDesc.content = description;
    }

    // Cleanup: restore defaults when unmounting
    return () => {
      const defaultTitle = 'My Bracket Sim';
      const defaultDesc = "Build your own what-if scenarios for your office basketball pool. Generate simulations to see who's actually winning-- and who's been eliminated.";
      const defaultUrl = `${BASE_URL}/`;

      document.title = defaultTitle;
      const linkEl = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (linkEl) linkEl.href = defaultUrl;

      const ogUrlEl = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
      if (ogUrlEl) ogUrlEl.content = defaultUrl;
      const ogTitleEl = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
      if (ogTitleEl) ogTitleEl.content = defaultTitle;
      const ogDescEl = document.querySelector<HTMLMetaElement>('meta[property="og:description"]');
      if (ogDescEl) ogDescEl.content = defaultDesc;
      const twitterTitleEl = document.querySelector<HTMLMetaElement>('meta[name="twitter:title"]');
      if (twitterTitleEl) twitterTitleEl.content = defaultTitle;
      const twitterDescEl = document.querySelector<HTMLMetaElement>('meta[name="twitter:description"]');
      if (twitterDescEl) twitterDescEl.content = defaultDesc;
      const metaDescEl = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (metaDescEl) metaDescEl.content = defaultDesc;
    };
  }, [title, description, path]);
}
